import lazyLoadView from '@router-utils/lazyload-view'
import routeError from '@router-utils/route-error'
import store from '@store'

export default [
  // ===
  // 儲值方案
  // ===
  {
    path: '/deposit',
    name: 'deposit',
    component: () => lazyLoadView(import('@views/Deposit/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        // try {
        //   if(!store.state.merchant.currentMerchant?.components.includes('deposit') || !store.state.merchant.currentMerchant?.depositSetting?.isEnabled) {
        //     next({ name: '404' })
        //   }
        //   const [
        //     list,
        //   ] = await Promise.all([
        //     store.dispatch('deposit/fetchDeposit'),
        //   ]);

        //   routeTo.params.list = list;

        //   next()
        // } catch (error) {
        //   routeError(error, routeTo, next({ name: '404' }), next);
        // }
        next()
      },
    },
    props: (route) => ({
      list: route.params.list || {},
    }),
  },
]
